import React from 'react';
import { Flex } from '@decisiv/ui-components';
import { P } from '@decisiv/ui-components/lib/components/Typography';

const ErrorBox = ({ errors }) => errors.length === 0 ? null : (
  <Flex
    flexDirection="column"
    gap={1}
    marginTop={2}
    padding={2}
    style={{ background: '#fff3f3', borderRadius: 4, border: '1px solid #f5c6cb' }}
  >
    {errors.map((msg, i) => (
      <P key={i} color="licorice" style={{ margin: 0 }}>{msg}</P>
    ))}
  </Flex>
);

export default ErrorBox;
